import { render, staticRenderFns } from "./ErrorCode.vue?vue&type=template&id=73ad9431"
import script from "./ErrorCode.vue?vue&type=script&lang=ts"
export * from "./ErrorCode.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../nuxt-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports